module.exports = __webpack_public_path__ + "static/img/banner2.7ec3991.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner2.png
// module id = 7rsh
// module chunks = 52